import RecapReportHeader from './RecapReportHeader';

export default RecapReportHeader;



// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/RecapReport/RecapReportHeader/index.tsx